export const MONTHS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

// Date complète, mois+année, année seule ou inconnue — jamais de jour/mois inventé
export const dateLabel = (p, kind = "birth") => {
  const y = p?.[`${kind}_year`];
  if (!y) return "";
  const m = p[`${kind}_month`], d = p[`${kind}_day`];
  const approx = p[`${kind}_year_approx`] ? "vers " : "";
  const parts = [m && d ? d : null, m ? MONTHS[m - 1] : null, y].filter(Boolean);
  return approx + parts.join(" ");
};

// « le 12 mars 1950 », « en mars 1950 », « en 1950 », « vers 1950 »
export const datePhrase = (p, kind = "birth") => {
  const label = dateLabel(p, kind);
  if (!label || label.startsWith("vers ")) return label;
  return p[`${kind}_day`] && p[`${kind}_month`] ? `le ${label}` : `en ${label}`;
};

export const lifeLabel = (p, unknown = "?") => {
  const b = dateLabel(p, "birth"), d = dateLabel(p, "death");
  return `${b || unknown}${d ? ` – ${d}` : ""}`;
};
